import React from 'react';
import ProductViewTemplate from '@/components/partials/ProductView/ProductViewTemplate';
import { useProductReadOnly } from '@/components/partials/ProductView/ProductReadOnly/useProductReadOnly';
import { ProductViewModes } from '@/utils/productStateUtils';

const ProductReadOnly = () => {
  const viewHook = useProductReadOnly();

  return (
    <ProductViewTemplate
      productViewMode={ProductViewModes.ReadOnly}
      viewHook={viewHook}
    />
  );
};

export default ProductReadOnly;
